import React from 'react'
import { PlainInput } from './PlainField';

const HiddenFields = ({ ...props }) => {
	props.type = 'hidden';
	return (<PlainInput {...props} />)
}

export default HiddenFields